/**
 * @generated SignedSource<<785824396f56bba4ed1faa7c25cd98da>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ArchivePage_page$data = {
  readonly archive: {
    readonly " $fragmentSpreads": FragmentRefs<"ArchiveList_component">;
  } | null | undefined;
  readonly breadcrumbs: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"Breadcrumb_data">;
  } | null | undefined> | null | undefined;
  readonly id: string;
  readonly path: string | null | undefined;
  readonly " $fragmentType": "ArchivePage_page";
};
export type ArchivePage_page$key = {
  readonly " $data"?: ArchivePage_page$data;
  readonly " $fragmentSpreads": FragmentRefs<"ArchivePage_page">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "salesAdmission"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ArchivePage_page",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "salesAdmission",
          "variableName": "salesAdmission"
        }
      ],
      "concreteType": "ArchiveList",
      "kind": "LinkedField",
      "name": "archive",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ArchiveList_component"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Breadcrumb",
      "kind": "LinkedField",
      "name": "breadcrumbs",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Breadcrumb_data"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "path",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "ArchivePage",
  "abstractKey": null
};

(node as any).hash = "3459c78ef6c874b4b7945b60c2837567";

export default node;
